import Vue from "vue";

export default {
	state: {
		item: {},
		isFetching: false,
		errorMessage: null,
		lastFetched: null // Timestamp
	},
	getters: {
		item: (state): any => state.item as any,
		error: (state): string => state.errorMessage,
		fetching: (state): boolean => state.isFetching
	},
	actions: {},
	mutations: {
		LOAD_ITEM_SUCCESS(state: any, item: any) {
			state.item = item;
			state.lastFetched = Date.now();
			state.isFetching = false;
		},
		LOAD_FINISH(state: any) {
			state.lastFetched = Date.now();
			state.isFetching = false;
		},
		LOAD_START(state: any) {
			state.errorMessage = null;
			state.isFetching = true;
		}
	}
};
